import styled from 'styled-components';

import { PopoverTrigger } from 'ui/popover';
import { Body2, Caption, colors, smallShadow, spacing, Subtitle1, subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { StyledBreakdownCardHeader } from '../Styled';

export const NBACardHeader = styled(StyledBreakdownCardHeader)`
  font-size: ${subtitle2};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.threeQuarter};
`;

export const NBACardHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${spacing.threeEights};
`;

export const NBACardHeaderTrigger = styled(PopoverTrigger)`
  color: ${colors.grey35};
  height: ${spacing.plusHalf};
`;

export const NBACardHeaderLogo = styled.div`
  display: flex;
  column-gap: ${spacing.quarter};
  align-items: center;
`;

export const LogoCaption = styled(Caption)`
  color: ${colors.textDisabled};
`;

export const NBACardContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${`${spacing.base} ${spacing.plusHalf}`};
`;

export const NBACardContentInfoContainer = styled.div`
  display: flex;
  column-gap: ${spacing.threeQuarter};
`;

export const NBACardContentHeader = styled(Subtitle1)`
  font-weight: bold;
  margin: 0;
`;

export const NBACardToggleContent = styled(Body2)`
  color: ${colors.textSecondary};
  width: ${pxToRem(248)};
`;

export const NBACardContentSubHeader = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const NBARecommendIconContainer = styled.div`
  ${smallShadow};
  border-radius: ${spacing.half};
  padding: ${spacing.half};
`;

export const NBACardContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: ${spacing.eighth};
`;
